import React from 'react';

import { Switch } from '@hcs/design-system';
import { MenuItem } from '@hcs/design-system';
import { OmFileIcon } from '@hcs/design-system';
import { usePatchReportPreferencesForOrg } from '@hcs/huell';
import { useReportPreferencesForOrg } from '@hcs/huell';

import styles from './OrgReportPreferences.module.css';

const dataHcName = 'client-file-id-required-control';
export const ClientFileIdRequiredControl = () => {
  const { isFetched, data: orgReportPrefs } = useReportPreferencesForOrg();
  const { mutate: patchOrgPrefs } = usePatchReportPreferencesForOrg();
  const currentPreferenceValue =
    !!orgReportPrefs?.preferences?.clientIdRequired;
  return (
    <MenuItem
      dataHcName={dataHcName}
      Icon={OmFileIcon}
      label={`Client File ID`}
      description={`Require users to enter a Client File ID when creating a PEXP report.`}
      contentRight={
        isFetched &&
        patchOrgPrefs && (
          <div className={styles.Switch}>
            <Switch
              switchOffOption={{
                value: false,
                dataHcName: `${dataHcName}-off`,
              }}
              switchOnOption={{
                value: true,
                dataHcName: `${dataHcName}-on`,
              }}
              dataHcName={`${dataHcName}-switch`}
              value={currentPreferenceValue}
              onChange={(value) => {
                patchOrgPrefs([
                  {
                    op: 'add',
                    path: '/clientIdRequired',
                    value,
                  },
                ]);
              }}
            />
            <div className={styles.SwitchLabel}>
              {currentPreferenceValue ? 'Required' : 'Optional'}
            </div>
          </div>
        )
      }
    />
  );
};
